import { type ReactNode } from 'react';
import { getSafeUserRequestContext, type ManagerPermissionAction, type ManagerPermissionName } from '../context';
import { hasPermission } from './hasPermission';

export function renderWithPermission<T extends ReactNode>(
    permission: ManagerPermissionName,
    action: ManagerPermissionAction,
    children: T
) {
    const { permissions } = getSafeUserRequestContext();

    if (!hasPermission(permissions, permission, action)) {
        return null;
    }

    return children;
}
